import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Icon from '~/core/scripts/components/icon';
import Utils from '~/core/scripts/utils';
import './BarChartViz.styl';

class BarChartViz extends PureComponent {
  static propTypes = {
    showOverallCountBar: PropTypes.bool,
    showOverallCountTitle: PropTypes.bool
  }

  static defaultProps = {
    showOverallCountBar: true,
    showOverallCountTitle: false
  }

  constructor(props) {
    super();

    const dataValues = props.data.filter(d => d.value).map(d => d.value);

    this.maxValue = props.showOverallCountBar ?
      props.overallCount : Math.max(...dataValues);
  }

  renderRowData(d) {
    return (
      <Fragment>
        <div className="barchartviz__row-title">
          <span className="text">{d.name}</span>
        </div>
        <div className="barchartviz__row-number">
          <span className="text">{Utils.numberFormat(d.value)}</span>
        </div>
        <div className="barchartviz__row-barwrapper">
          <div
            className="barchartviz__row-bar"
            style={{ width: `${(d.value / this.maxValue) * 100}%` }}
          />
        </div>
      </Fragment>
    );
  }

  renderRow(d) {
    return (
      <div className="barchartviz__row" key={d.name}>
        <div className="barchartviz__row-data barchartviz__row-main">
          {this.renderRowData(d)}
        </div>
        {d.sub && (
          <div className="barchartviz__row-data barchartviz__row-sub">
            {this.renderRowData(d.sub)}
          </div>
        )}
      </div>
    );
  }

  renderLabel(label) {
    return (
      <div className="barchartviz__row" key={label}>
        <div className="barchartviz__row-label">
          {label}
        </div>
      </div>
    );
  }

  render() {
    const { title, data, overallCount, icon, showOverallCountBar, showOverallCountTitle, className } = this.props;
    const wrapperClasses = classnames('barchartviz', className);
    return (
      <div className={wrapperClasses}>
        <div className="barchartviz__headline viz__headline">
          {title}
          {!showOverallCountTitle && <Icon type={icon}/>}
        </div>
        {showOverallCountTitle && (
          <div className="barchartviz__counttitle viz__subheadline">
            {Utils.numberFormat(overallCount)}
            <Icon type={icon}/>
          </div>
        )}
        <div className="barchartviz__items">
          {data.map(d => d.label ? this.renderLabel(d.label) : this.renderRow(d))}
        </div>
        {showOverallCountBar && (
          <div className="barchartviz__overall">
            {this.renderRow({ name: 'Gesamt', value: overallCount })}
          </div>
        )}
      </div>
    );
  }
}

export default BarChartViz;
